<template>
  <footer id="colophon" class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-4 col-xs-6">
          <a class="site-title"
            ><span>Zhu Ge Kong Ming Sdn Bhd</span> 諸葛孔明有限公司</a
          >
          <p>
            本公司经营销售各样的神料用品有如 还债金, 壽生钱 太岁殿,
            南斗六星延寿。
          </p>
        </div>
        <div
          class="col-lg-offset-4 col-md-3 col-sm-4 col-md-offset-2 col-sm-offset-0 col-xs-6 "
        >
          <h3>联系方式</h3>
          <ul class="list-unstyled contact-links">
            <li>
              <i class="fa fa-envelope" aria-hidden="true"></i
              ><a href="mailto:zgkmsb@gmail.com">zgkmsb@gmail.com</a>
            </li>
            <li>
              <i class="fa fa-phone" aria-hidden="true"></i
              ><a href="tel:+60379838560">+603-7983 8560</a>
            </li>
            <li>
              <i class="fa fa-whatsapp" aria-hidden="true"></i
              ><a href="https://wa.me/60162822252">+6016-282 2252</a>
            </li>
            <li>
              <i class="fa fa-map-marker" aria-hidden="true"></i>
              <p>
                71 & 73, Jalan Hujan Emas 8, Taman Overseas Union, 58200 Kuala
                Lumpur, Wilayah Persekutuan Kuala Lumpur
              </p>
            </li>
          </ul>
        </div>
        <div class="clearfix visible-xs"></div>
        <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
          <h3>特色链接</h3>
          <ul class="list-unstyled">
            <li><router-link to="/">首页</router-link></li>
            <!-- <li><router-link to="/">关于我们</router-link></li> -->
            <li><router-link to="/products">产品</router-link></li>
            <li><router-link to="/contact-us">联系我们</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <div class="row">
          <div class="col-xs-8">
            <div class="social-links">
              <a
                class="facebook-bg"
                href="https://www.facebook.com/profile.php?id=100068423528561"
                ><i class="fa fa-facebook"></i
              ></a>
            </div>
            <!-- /.social-links -->
          </div>
          <div class="col-xs-4">
            <div class="text-right">
              <p>&copy; Zhu Ge Kong Ming Sdn Bhd 諸葛孔明有限公司</p>
              <p>All Rights Reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.copyright -->
    <Backtotop />
  </footer>
  <!-- /#footer -->
</template>

<script>
/* eslint-disable */
import Backtotop from "./Backtotop.vue";

export default {
  name: "Footer",
  data() {
    return {};
  },
  components: {
    Backtotop
  }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue